export const baseURL = process.env.REACT_APP_BONOBO_ADDON_API_URL
    ?
    process.env.REACT_APP_BONOBO_ADDON_API_URL
    :
    'http://192.168.1.4:4000/';

export const refreshToken = (res) => {
    console.log(res)
}